import React, { useState, useEffect } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useQuery } from "@apollo/client";
//Icons
import { BsPrinter } from "react-icons/bs";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
//Srcs
import "../../Style/actionstyle.scss";
import CreatePayDisbursement from "./CreatePayDisbursement";

export default function PayDisbursementAction({ editData, setRefetch }) {
  //Modal update
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="Payment" placement="top">
          <IconButton onClick={handleOpen}>
            <Box className="update-container">
              <RiMoneyDollarCircleLine className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <CreatePayDisbursement
        open={open}
        handleClose={handleClose}
        editData={editData}
      />
    </div>
  );
}
